import React from "react";
import styled from "styled-components";

export default ({ objectives, main_objective }) => (
  <Wrap className="pa3 bg-white br2 mb3">
    <div className="fw6 f5 bb pb2 mb2 b--black-20 ">Objectives</div>
    {main_objective.label}
    <div className="f6">
      You are purchasing a 30 min phone call with the insider of your choice.
      The call will be guided by your objectives. The Lobby does not guarantee
      referrals, jobs, or interview, as this would be a false promise and a
      conflict of interest for our insiders.
    </div>
    <div className="fw6 f5 bb pb2 mb2 b--black-20">Additional notes?</div>
    <div className="f6">
      You are purchasing a 30 min phone call with the insider of your choice.
      The call will be guided by your objectives. The Lobby does not guarantee
      referrals, jobs, or interview, as this would be a false promise and a
      conflict of interest for our insiders.
    </div>
  </Wrap>
);

const Wrap = styled.div`
  background-color: #ebe8e1;
  border-top: 8px solid #000000;
  font-family: CircularStd-Book, sans-serif;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/InfoCard.js